<template>
  <b-container>
    <b-row>
      <b-col
        v-for="(post, index) in posts.slice().reverse()"
        :key="index"
        lg="4"
        md="12"
      >
        <div class="myCard h-100">
          <div class="myCardInner h-100">
            <PostPreview :post="post"/>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import PostPreview from "./PostPreview";

export default {
  name: "Gallery",
  components: {
    PostPreview
  },
  props: {
    posts: {
      type: Array,
      required: true
    }
  },
  computed: {
    date() {
      return new Date(this.post.date).toString();
    }
  }
};
</script>

<style scoped>
.myCard {
  padding-bottom: 5px;
}

.myCardInner {
  background-color: white;
  border: 0.3em solid rgba(66, 66, 66, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue